import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaPaperPlane,
} from "react-icons/fa";
import { motion } from "framer-motion";
import axios from "axios";
import { API_URL } from "../utils/url";
import { toast } from "react-toastify";
const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    desc: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post(
        `${API_URL}/api/contact/create-contact`,
        formData,
      );

      toast.success("Message sent successfully");

      setFormData({
        name: "",
        mobile: "",
        email: "",
        desc: "",
      });
    } catch (error) {
      console.error(error);

      toast.error("Something went wrong");
    }
  };

  return (
    <section
      id="contact"
      className="py-3"
      style={{ backgroundColor: "#fffaf5" }}
    >
      <Container className="py-lg-5">
        <div className="text-center mb-5">
          <h6 className="text-warning fw-bold text-uppercase tracking-widest">
            Connect With Us
          </h6>
          {/* <h2 className="font-serif display-5" style={{ color: "#431407" }}>
            Anant Sewa Ashram
          </h2> */}
          <div
            className="mx-auto bg-warning mt-2"
            style={{ height: "3px", width: "80px" }}
          ></div>
        </div>

        <Row className="shadow-lg g-0 rounded-4 overflow-hidden border border-warning-subtle">
          {/* Left Side: Information */}
          <Col
            md={5}
            className="p-5 text-white d-flex flex-column justify-content-center"
            style={{
              backgroundColor: "#431407",
              backgroundImage:
                "radial-gradient(circle at 10% 20%, rgba(218, 165, 32, 0.1) 0%, transparent 90%)",
            }}
          >
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              <h3 className="font-serif mb-5 display-6 border-start border-warning ps-3">
                Contact Info
              </h3>

              <div className="d-flex mb-4 gap-4 align-items-center">
                <div className="icon-box">
                  <FaMapMarkerAlt />
                </div>
                <div>
                  <h6 className="text-warning mb-1 text-uppercase small tracking-wider">
                    Ashram Address
                  </h6>
                  <p className="mb-0 opacity-75">
                    Shree Vishnu Dham, Parikrama Marg,
                    <br /> Vrindavan, Mathura (U.P)
                  </p>
                </div>
              </div>

              <div className="d-flex mb-4 gap-4 align-items-center">
                <div className="icon-box">
                  <FaPhoneAlt />
                </div>
                <div>
                  <h6 className="text-warning mb-1 text-uppercase small tracking-wider">
                    contact Number
                  </h6>
                  <p className="mb-0 opacity-75">+91 81719 74067</p>
                </div>
              </div>

              <div className="d-flex mb-4 gap-4 align-items-center">
                <div className="icon-box">
                  <FaEnvelope />
                </div>
                <div>
                  <h6 className="text-warning mb-1 text-uppercase small tracking-wider">
                    Official Email
                  </h6>
                  <p className="mb-0 opacity-75">contact@vishnujimaharaj.com</p>
                </div>
              </div>
            </motion.div>
          </Col>

          {/* Right Side: Form */}
          <Col md={7} className="p-5 bg-white">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <h3 className="font-serif mb-4 text-dark">
                Send a Divine Message
              </h3>
              <p className="text-muted mb-4 small">
                Aapke mann mein koi prashan ho ya katha ke liye sampark karna
                ho, kripya niche diye gaye form ko bharein.
              </p>

              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={6} className="mb-4">
                    <Form.Group>
                      <Form.Label
                        className="small fw-bold text-uppercase text-muted"
                        style={{ fontSize: "10px" }}
                      >
                        Full Name
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        value={formData.name}
                        placeholder="Full Name"
                        className="custom-input p-3 shadow-none"
                        onChange={(e) =>
                          setFormData({ ...formData, name: e.target.value })
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6} className="mb-4">
                    <Form.Group>
                      <Form.Label
                        className="small fw-bold text-uppercase text-muted"
                        style={{ fontSize: "10px" }}
                      >
                        Mpbile
                      </Form.Label>
                      <Form.Control
                        type="tel"
                        placeholder="mobile number"
                        name="mobile"
                        value={formData.mobile}
                        className="custom-input p-3 shadow-none"
                        onChange={(e) =>
                          setFormData({ ...formData, mobile: e.target.value })
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={12} className="mb-4">
                    <Form.Group>
                      <Form.Label
                        className="small fw-bold text-uppercase text-muted"
                        style={{ fontSize: "10px" }}
                      >
                        Email Address
                      </Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={formData.email}
                        placeholder="example@gmail.com"
                        className="custom-input p-3 shadow-none"
                        onChange={(e) =>
                          setFormData({ ...formData, email: e.target.value })
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Form.Group className="mb-4">
                  <Form.Label
                    className="small fw-bold text-uppercase text-muted"
                    style={{ fontSize: "10px" }}
                  >
                    Your Message / Inquiry
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    name="desc"
                    value={formData.desc}
                    placeholder="How can we help you?"
                    className="custom-input p-3 shadow-none"
                    onChange={(e) =>
                      setFormData({ ...formData, desc: e.target.value })
                    }
                  />
                </Form.Group>
                <Button
                  type="submit"
                  className="w-100 py-3 fw-bold tracking-widest border-0 submit-btn"
                  style={{ backgroundColor: "#431407" }}
                >
                  <FaPaperPlane className="me-2" /> SEND MESSAGE
                </Button>
              </Form>
            </motion.div>
          </Col>
        </Row>
      </Container>

      <style>{`
        .icon-box {
          background: rgba(218, 165, 32, 0.15);
          color: #DAA520;
          padding: 12px;
          border-radius: 50%;
          font-size: 1.2rem;
          display: flex;
          align-items: center;
          justify-content: center;
          min-width: 50px;
          height: 50px;
        }
        .custom-input {
          border: 1px solid #eee !important;
          background: #fdfdfd !important;
          transition: 0.3s;
          border-radius: 8px !important;
        }
        .custom-input:focus {
          border-color: #DAA520 !important;
          background: #fff !important;
        }
        .submit-btn {
          transition: 0.4s;
          border-radius: 8px !important;
        }
        .submit-btn:hover {
          background-color: #DAA520 !important;
          transform: translateY(-3px);
          box-shadow: 0 10px 20px rgba(67, 20, 7, 0.2);
        }
        @media (max-width: 768px) {
          .rounded-4 { border-radius: 15px !important; }
        }
      `}</style>
    </section>
  );
};

export default Contact;
